import {
  AddressCallout as DSAddressCallout,
  AddressCalloutProps,
  AddressCalloutRenderLinkComponent,
} from "@opensea/ui-kit"
import React, { ElementRef, forwardRef } from "react"
import { Link } from "../Link"

export const AddressCallout = forwardRef<
  ElementRef<typeof DSAddressCallout>,
  AddressCalloutProps
>(function NextAddressCallout(props, ref) {
  return (
    <DSAddressCallout
      renderLink={Link as AddressCalloutRenderLinkComponent}
      {...props}
      ref={ref}
    />
  )
})
